export default {
    // User interface
    alt_filters_filter: "LED-korvaavuus",
    ballast_notice: "Elektronisen liitäntälaitteen (HF) ja LED-valoputken yhteensopivuus tulee tarkistaa yhteensopivuuslistauksesta.",
    ballast_notice_tled_link_text: "LED-valoputket",
    ballast_notice_pl_led_link_text: "PL LED-lamput",
    led_no_recommendations: "Tuotteelle ei ole LED-korvaajaa",

    // LED facets
    tiering: "Tuoteperhe",
    ballast_compatibility: "Liitäntälaitteen yhteensopivuus",
    lifetime: "Elinikä",
    lumen: "Valovirta",
    
    // Others
    home_search_for_product: "Etsi vastaava tuote",
    conventional_alternative: "Perinteinen valonlähde",
    led_alternative: "Korvaava LED-valonlähde",
    search_filters_filter: "Valitse",
    search_submit: "Etsi tuotetta",
    results: "Tulokset",
    selected_product: "Valittu tuote",
    search_input: "Kirjoita osa tuotekoodista tai tuotekuvauksesta",
    what_type_are_you_looking_for: "Millaista korvaavaa tuotetta etsit?",
    recommendations_singular: "Suositetut tuotteet",
    recommendations_plural: "Suositetut tuotteet",
    your_product: "Tuotteesi",
    search_filters_reset: "Nollaa valinnat",
    results_specify: "Yli 10 hakutulosta – tarkenna hakukriteerejä",
    energy_efficient: "Energia tehokas",
    active_filters: "Aktiiviset valinnat",
    card_action: "Tuoteluettelo",
    card_show_more: "Näytä lisää",
    card_show_less: "Näytä vähemmän",
    card_alternative_fit: "Philipsin paras vaihtoehto",
    card_perfect_fit: "Philipsin paras valinta",
    no_results_found: "Ei hakutuloksia. Hae uudestaan erilaisilla hakukriteereillä.",
    results_no_recommendations: "Ei tuloksia? Ota yhteyttä myyntiedustajaan, joka auttaa sopivan ratkaisun löytämisessä.",
    search_filter_product_type: "Tuotetyyppi",
    lighting_type: "Lampputyyppi",
    ean: "EAN",
    product_code: "Tuotekoodi",
    eoc: "Kokonaiskustannusarvio",
    family: "Tuoteperhe",
    discrete_wattage: "Wattiteho",
    wattage: "Wattiteho",
    brand: "Tuotemerkki",
    driver_type: "Liitäntälaitetyyppi",
    number_of_lamps: "Lamppujen lukumäärä",
    length: "Pituus",
    color: "Värilämpötila",
    base: "Kanta",
    local_eoc: "Sähkönumero",
    ignitor: "Sytytin",
    height: "Korkeus",
    width: "Leveys",
    mounting_hole: "Aukon koko",
    mains_voltage: "Verkkojännite",
    thermal_protection: "Lämpösuojaus",
    delta_temperature: "Delta-T",
    energy_efficiency: "Energiatehokkuusluokka",
    losses: "Tehohäviö",
    lamp_current: "Lampun virta",
    pf_cap: "Kompensointikondensaattori",
    energy_saving: "Energiansäästö",
};
